var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("ClaimsManagement.batchUpdateDeductionStatus"),
            visible: _vm.batchDebitStatusDialog,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchDebitStatusDialog = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "upload-step" }, [
            _c("h3", [
              _vm._v(
                "1. " + _vm._s(_vm.$t("uploadFile.uploadFileTitle")) + " "
              ),
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
            ]),
            _c(
              "div",
              {
                staticClass: "upload-dragger",
                on: { click: _vm.triggerFileUpload },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "drag-area",
                    class: { "is-dragover": _vm.isDragover },
                    on: {
                      dragover: function ($event) {
                        $event.preventDefault()
                        _vm.isDragover = true
                      },
                      dragleave: function ($event) {
                        $event.preventDefault()
                        _vm.isDragover = false
                      },
                      drop: function ($event) {
                        $event.preventDefault()
                        return _vm.handleDrop($event)
                      },
                    },
                  },
                  [
                    _c("input", {
                      ref: "referenceUpload",
                      staticStyle: { display: "none" },
                      attrs: { accept: ".xlsx,.xls,.csv", type: "file" },
                      on: {
                        change: function ($event) {
                          return _vm.handleFileChange($event)
                        },
                      },
                    }),
                    _c("div", { staticClass: "upload-icon-wrapper" }, [
                      _c("i", { staticClass: "el-icon-upload" }),
                    ]),
                    !_vm.uploadFile
                      ? _c("div", [
                          _c("p", { staticClass: "drag-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("ClaimsManagement.dragOrClickToUpload")
                              )
                            ),
                          ]),
                          _c("p", { staticClass: "drag-hint" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("ClaimsManagement.fileFormatAndLimit")
                                ) +
                                ","
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("ClaimsManagement.max10000Records")
                                  )
                              ),
                            ]),
                          ]),
                        ])
                      : _c("div", { staticClass: "file-selected" }, [
                          _c("i", { staticClass: "el-icon-document" }),
                          _c("span", { staticClass: "file-name" }, [
                            _vm._v(_vm._s(_vm.uploadFile.name)),
                          ]),
                          _c("span", { staticClass: "file-size" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  (_vm.uploadFile.size / 1024).toFixed(2)
                                ) +
                                " KB)"
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "remove-file",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeFile($event)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-delete" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("ClaimsManagement.Remove")) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "tip-info" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.$t("ClaimsManagement.downloadTemplateFirst"),
                      effect: "dark",
                      placement: "top-start",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-info" })]
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("ClaimsManagement.downloadTemplateFirst"))
                  ),
                ]),
                _c(
                  "a",
                  {
                    staticClass: "download-link",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadTemplate($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("receivablePayable.DownloadTheTemplate")) +
                        " (.xlsx)"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelUpload } }, [
                _vm._v(_vm._s(_vm.$t("customerManagements.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.uploading, type: "primary" },
                  on: { click: _vm.confirmUpload },
                },
                [_vm._v(_vm._s(_vm.$t("ClaimsManagement.confirmUpload")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("ClaimsManagement.uploadResult"),
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleCloseResult,
          },
        },
        [
          _c("div", { staticClass: "stats-cards" }, [
            _c("div", { staticClass: "card blue-card" }, [
              _c("div", { staticClass: "number" }, [
                _vm._v(_vm._s(_vm.failTipData.totalCount)),
              ]),
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("ClaimsManagement.Remove"))),
              ]),
            ]),
            _c("div", { staticClass: "card green-card" }, [
              _c("div", { staticClass: "number" }, [
                _vm._v(_vm._s(_vm.failTipData.successCount)),
              ]),
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("ClaimsManagement.successCount"))),
              ]),
            ]),
            _c("div", { staticClass: "card red-card" }, [
              _c("div", { staticClass: "number" }, [
                _vm._v(_vm._s(_vm.failTipData.failCount)),
              ]),
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("ClaimsManagement.failCount"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "fail-detail" }, [
            _vm.failTipData.failCount > 0
              ? _c(
                  "div",
                  { staticClass: "detail-header" },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("ClaimsManagement.failureDetails"))),
                    ]),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDownload(1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("ClaimsManagement.fixAndReupload")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      color: "#909399",
                      padding: "20px",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ClaimsManagement.noFailureData")) +
                        " "
                    ),
                  ]
                ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.failTipData.failCount > 0
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDownload(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("ClaimsManagement.downloadFailureDetails")
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("orderExport.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }